import React, { FormEvent } from "react";
import { api, CompanyDto } from "shared/api";
import { formatDate, useApiMethod, UseModalProps } from "shared/lib";
import { Avatar, Entity, Error, LoadingDots, Modal } from "shared/ui";

export interface ICompanyDeleteModal extends UseModalProps {
  data: CompanyDto;
}

export const CompanyDeleteModal = (props: ICompanyDeleteModal) => {
  const submit = useApiMethod(api.company.companyArchive);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    await submit.call(props.data.id);
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={450}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Удаление компании</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Entity>
            <Entity.Field
              avatar={<Avatar {...props.data} size={39} />}
              title={props.data.name}
              description={<>Создана {formatDate(props.data.createdAt)}</>}
            />
          </Entity>

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Отмена
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Удалить" : <LoadingDots size={4}>Удаление</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

CompanyDeleteModal.defaultProps = {};
